import { Avatar } from '@mui/material'
import React, { useState } from 'react'
import GenerateIcon from './GenerateIcon'

interface IThumbnailProps {
    src?: string,
    alt?: string,
    size?: number | string, // default could be 40 or '40px'
    fallback?: React.ReactNode,
    className?: string,
    style?: React.CSSProperties,
    onClick?: () => void,
}

export default function Thumbnail(props: IThumbnailProps) {

    const [show, setShow] = useState<boolean>(false)

    const handleShow = () => {
        if (!props.src){
            return;
        }

        setShow(true)
    }

    const handleClose = () => setShow(false)

    return(
        <div className="thumbnail-wrapper">

            {props.src && (
                <div className={show ? "thumbnail-preview active" : "thumbnail-preview"} onClick={() => handleClose()}>
                    <div className="content-of-thumbnail-preview">
                        <img src={props.src} />
                    </div>
                </div>
            )}

            <div className="thumbnail-component" onClick={() => handleShow()}>
                <Avatar {...props}>
                    <GenerateIcon icon="image" />
                </Avatar>
            </div>
        </div>
    )
}